import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'

import App from '@/app'

Sentry.init({
  dsn: 'https://ef5736ad09f05c2d0b3ce5c8df2d2c4b@o4507667451150336.ingest.us.sentry.io/4511293671866368',
  sendDefaultPii: true,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
